import _extends from'@babel/runtime/helpers/extends';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import React,{useCallback}from'react';import PropTypes from'prop-types';import styled from'styled-components';import {Link as Link$2}from'react-router-dom';import {typography,TextLink}from'@manulife/mux';import noop from'../../utils/noop.js';import {sendAdobeAnalyticsClick,sendAdobeAnalyticsTransaction}from'../Analytics/AdobeAnalytics.js';var TextButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "Link__TextButton",
  componentId: "sc-151t7i9-0"
})(["border:none;background:none;padding:0;margin:0;text-decoration:underline;cursor:pointer;font-family:", ";font-size:", ";font-weight:", ";font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:normal;color:", ";"], typography.fontFamily, typography.fontSize, typography.fontWeightLight, function (_ref) {
  var theme = _ref.theme;
  return theme.colorPalette.primaryColors.main.shade_link;
});
var Link = function Link(_ref2) {
  var to = _ref2.to,
    onClick = _ref2.onClick,
    analyticsData = _ref2.analyticsData,
    children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, ["to", "onClick", "analyticsData", "children"]);
  var relative = to === null || to === void 0 ? void 0 : to.startsWith('/');
  var as = relative ? Link$2 : 'a';
  var handleClick = useCallback(function () {
    onClick === null || onClick === void 0 ? void 0 : onClick();
    if (analyticsData !== null && analyticsData !== void 0 && analyticsData.click) {
      sendAdobeAnalyticsClick({
        click: analyticsData.click
      });
    }
    if (analyticsData !== null && analyticsData !== void 0 && analyticsData.transaction && analyticsData !== null && analyticsData !== void 0 && analyticsData.transactionEvent) {
      sendAdobeAnalyticsTransaction(analyticsData.transactionEvent, {
        transaction: analyticsData.transaction
      });
    }
  }, [analyticsData, onClick]);
  if (to) {
    return /*#__PURE__*/React.createElement(TextLink, _extends({
      onClick: handleClick,
      to: to,
      as: as
    }, rest), children);
  }
  return /*#__PURE__*/React.createElement(TextButton, _extends({}, rest, {
    type: "button",
    onClick: handleClick
  }), children);
};
process.env.NODE_ENV !== "production" ? Link.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string,
  onClick: PropTypes.func,
  analyticsData: PropTypes.object
} : void 0;
Link.defaultProps = {
  to: '',
  onClick: noop,
  analyticsData: {}
};
var Link$1 = Link;export{Link$1 as default};